module.exports = __webpack_public_path__ + "img/table.ab57bb6a.png";